import { render } from "./MarketingPage.vue?vue&type=template&id=766615ae&ts=true"
import script from "./MarketingPage.vue?vue&type=script&lang=ts"
export * from "./MarketingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__